import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
export default function OrderLookupPage() {
    const [email, setEmail] = useState('');
    const [orderId, setOrderId] = useState('');
    const navigate = useNavigate();
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (email && orderId) {
            navigate(`/account/orders/${encodeURIComponent(orderId)}?email=${encodeURIComponent(email)}`);
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "max-w-md mx-auto px-4 sm:px-6 lg:px-8 py-16",
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: "font-display text-4xl text-stone-900 uppercase tracking-wide mb-2 text-center",
                children: "Order Lookup"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text-sm text-stone-500 text-center mb-8",
                children: "Enter your email and order ID to check your order status."
            }),
            /*#__PURE__*/ _jsxs("form", {
                onSubmit: handleSubmit,
                className: "bg-white border-2 border-stone-100 p-6 space-y-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                htmlFor: "email",
                                className: "block text-xs font-semibold uppercase tracking-wider text-stone-700 mb-1",
                                children: "Email"
                            }),
                            /*#__PURE__*/ _jsx("input", {
                                id: "email",
                                type: "email",
                                value: email,
                                onChange: (e)=>setEmail(e.target.value),
                                className: "w-full border-2 border-stone-200 px-3 py-2 text-sm focus:border-stone-900 focus:outline-none",
                                placeholder: "you@example.com",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                htmlFor: "orderId",
                                className: "block text-xs font-semibold uppercase tracking-wider text-stone-700 mb-1",
                                children: "Order ID"
                            }),
                            /*#__PURE__*/ _jsx("input", {
                                id: "orderId",
                                type: "text",
                                value: orderId,
                                onChange: (e)=>setOrderId(e.target.value),
                                className: "w-full border-2 border-stone-200 px-3 py-2 text-sm focus:border-stone-900 focus:outline-none",
                                placeholder: "e.g. ord_abc123...",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "submit",
                        className: "w-full py-3 bg-stone-900 text-white text-xs font-semibold uppercase tracking-wider hover:bg-stone-700",
                        children: "Look Up Order"
                    })
                ]
            })
        ]
    });
}
